import { LeadsFilter } from '../../services/leads.service'

interface LeadFiltersProps {
  filters: LeadsFilter
  onChange: (filters: LeadsFilter) => void
}

export default function LeadFilters({ filters, onChange }: LeadFiltersProps) {
  const statuses = [
    { value: '', label: 'Все статусы' },
    { value: 'pending_review', label: 'На рассмотрении' },
    { value: 'approved', label: 'Одобренные' },
    { value: 'rejected', label: 'Отклонённые' },
    { value: 'message_generated', label: 'Сообщение готово' },
    { value: 'sent', label: 'Отправленные' },
    { value: 'replied', label: 'С ответом' },
  ]

  return (
    <div className="card mb-6">
      <div className="flex flex-wrap gap-4">
        {/* Status Filter */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Статус
          </label>
          <select
            value={filters.status || ''}
            onChange={(e) =>
              onChange({
                ...filters,
                status: e.target.value || undefined,
                offset: 0,
              })
            }
            className="input"
          >
            {statuses.map((status) => (
              <option key={status.value} value={status.value}>
                {status.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date From */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дата от
          </label>
          <input
            type="date"
            value={filters.date_from || ''}
            onChange={(e) =>
              onChange({
                ...filters,
                date_from: e.target.value || undefined,
                offset: 0,
              })
            }
            className="input"
          />
        </div>

        {/* Date To */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дата до
          </label>
          <input
            type="date"
            value={filters.date_to || ''}
            onChange={(e) =>
              onChange({
                ...filters,
                date_to: e.target.value || undefined,
                offset: 0,
              })
            }
            className="input"
          />
        </div>

        {/* Per Page */}
        <div className="flex-1 min-w-[150px]">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            На странице
          </label>
          <select
            value={filters.limit || 50}
            onChange={(e) =>
              onChange({
                ...filters,
                limit: parseInt(e.target.value),
                offset: 0,
              })
            }
            className="input"
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        {/* Reset Button */}
        <div className="flex items-end">
          <button
            onClick={() =>
              onChange({
                limit: 50,
                offset: 0,
              })
            }
            className="px-4 py-2 text-gray-600 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Сбросить
          </button>
        </div>
      </div>
    </div>
  )
}
